import { useEffect, useState, useCallback } from 'react';
import { fetchJson } from '../../../helpers/fetch.js';
import queryClient from '../../../../query_client.js';

import {
  project_resource_form_options_path
} from '~/routes';

export const useProjectResourceFormOptions = ({ projectId }) => {
  const queryKey = ['project_resource_form_options', projectId];

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(!!projectId);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!projectId) return;

    try {
      setIsLoading(true);
      setIsError(false);

      const result = await queryClient.fetchQuery({
        queryKey,
        queryFn: () =>
          fetchJson(
            project_resource_form_options_path({ project_id: projectId })
          ),
        staleTime: 60 * 1000
      });

      setData(result);
    } catch (err) {
      setIsError(true);
      setError(err);
    } finally {
      setIsLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    user_types: data?.user_types,
    settings: data?.settings,
    isLoading,
    isError,
    error,
    refetch: fetchData
  };
};